import { merge } from "lodash";
import { HInfo } from "../components/HInfo/HInfo";
import { CoreConfigContextProps } from "../providers";

// coreConfig contains the value passed to CoreConfigProvider and is used by
// modules that are not react component that cannot have access to the react
// context.
export let coreConfig: CoreConfigContextProps = {
  appName: "no-name",
  allowedPaths: [],
  defaultPath: "",
  appVersion: "no-version",
  assets: {
    Info: HInfo,
  },
  onOpenChatRequest: undefined,
  onCloseChatRequest: undefined,
};

export const setCoreConfig = (config: Partial<CoreConfigContextProps>) => {
  coreConfig = merge(coreConfig, config);
};

export const getCoreConfig = () => {
  return coreConfig;
};
